import { fetchWithRetry } from "./utils"; // Utility function for fetching with retries  
// import { getAuthToken } from './auth'; // Uncomment if you need to include an auth token  
  
// Competition API Requests  
  
// Fetch a Competition by ID  
export const fetchCompetition = async (id) => {  
    try {  
        const response = await fetchWithRetry('/api/competitions/get', {  
            method: 'POST',  
            headers: {  
                'Content-Type': 'application/json',  
                // 'Authorization': `Bearer ${getAuthToken()}`, // Include if using auth tokens  
            },  
            body: JSON.stringify({ id }),  
        });  
  
        if (!response.ok) {  
            throw new Error('Failed to fetch competition');  
        }  
  
        const data = await response.json();  
        return data;  
    } catch (error) {  
        console.error('Error fetching competition:', error);  
        throw error;  
    }  
};  
  
// Fetch All Competitions  
export const fetchAllCompetitions = async () => {  
    try {  
        const response = await fetchWithRetry('/api/competitions/all', {  
            method: 'GET',  
            headers: {  
                'Content-Type': 'application/json',  
                // 'Authorization': `Bearer ${getAuthToken()}`,  
            },  
        });  
  
        if (!response.ok) {  
            throw new Error('Failed to fetch all competitions');  
        }  
  
        const data = await response.json();  
        return data;  
    } catch (error) {  
        console.error('Error fetching all competitions:', error);  
        throw error;  
    }  
};  
  
// Create a New Competition  
export const createCompetition = async (competitionData) => {  
    try {  
        const response = await fetchWithRetry('/api/competitions', {  
            method: 'POST',  
            headers: {  
                'Content-Type': 'application/json',  
                // 'Authorization': `Bearer ${getAuthToken()}`,  
            },  
            body: JSON.stringify(competitionData),  
        });  
  
        if (!response.ok) {  
            throw new Error('Failed to create competition');  
        }  
  
        const data = await response.json();  
        return data;  
    } catch (error) {  
        console.error('Error creating competition:', error);  
        throw error;  
    }  
};  
  
// Update a Competition  
export const updateCompetition = async (competitionData) => {  
    try {  
        const response = await fetchWithRetry('/api/competitions/update', {  
            method: 'POST',  
            headers: {  
                'Content-Type': 'application/json',  
                // 'Authorization': `Bearer ${getAuthToken()}`,  
            },  
            body: JSON.stringify(competitionData),  
        });  
  
        if (!response.ok) {  
            throw new Error('Failed to update competition');  
        }  
  
        const data = await response.json();  
        return data;  
    } catch (error) {  
        console.error('Error updating competition:', error);  
        throw error;  
    }  
};  
  
// Delete a Competition  
export const deleteCompetition = async (id) => {  
    try {  
        const response = await fetchWithRetry('/api/competitions/delete', {  
            method: 'POST',  
            headers: {  
                'Content-Type': 'application/json',  
                // 'Authorization': `Bearer ${getAuthToken()}`,  
            },  
            body: JSON.stringify({ id }),  
        });  
  
        if (!response.ok) {  
            throw new Error('Failed to delete competition');  
        }  
  
        const data = await response.json();  
        return data;  
    } catch (error) {  
        console.error('Error deleting competition:', error);  
        throw error;  
    }  
};  
  
// Province API Requests within a Competition  
  
// Create a New Province in a Competition  
export const createProvince = async (competitionId, provinceData) => {  
    try {  
        const response = await fetchWithRetry(`/api/competitions/${competitionId}/provinces`, {  
            method: 'POST',  
            headers: {  
                'Content-Type': 'application/json',  
                // 'Authorization': `Bearer ${getAuthToken()}`,  
            },  
            body: JSON.stringify(provinceData),  
        });  
  
        if (!response.ok) {  
            throw new Error('Failed to create province');  
        }  
  
        const data = await response.json();  
        return data;  
    } catch (error) {  
        console.error('Error creating province:', error);  
        throw error;  
    }  
};  
  
// Fetch All Provinces in a Competition  
export const fetchProvinces = async (competitionId) => {  
    try {  
        const response = await fetch(`/api/competitions/${competitionId}/provinces`, {  
            method: 'GET',  
            headers: {  
                'Content-Type': 'application/json',  
                // 'Authorization': `Bearer ${getAuthToken()}`,  
            },  
        });  
  
        if (!response.ok) {  
            throw new Error('Failed to fetch provinces');  
        }  
  
        const data = await response.json();  
        return data;  
    } catch (error) {  
        console.error('Error fetching provinces:', error);  
        throw error;  
    }  
};  
  
// Update a Province in a Competition  
export const updateProvince = async (competitionId, provinceId, provinceData) => {  
    try {  
        const response = await fetchWithRetry(`/api/competitions/${competitionId}/provinces/${provinceId}`, {  
            method: 'PATCH',  
            headers: {  
                'Content-Type': 'application/json',  
                // 'Authorization': `Bearer ${getAuthToken()}`,  
            },  
            body: JSON.stringify(provinceData),  
        });  
  
        if (!response.ok) {  
            const errorText = await response.text();  
            throw new Error(`Failed to update province: ${errorText}`);  
        }  
  
        const data = await response.json();  
        return data;  
    } catch (error) {  
        console.error('Error updating province:', error);  
        throw error;  
    }  
};  
  
// Delete a Province from a Competition  
export const deleteProvince = async (competitionId, provinceId) => {  
    try {  
        const response = await fetchWithRetry(`/api/competitions/${competitionId}/provinces/${provinceId}`, {  
            method: 'DELETE',  
            headers: {  
                'Content-Type': 'application/json',  
                // 'Authorization': `Bearer ${getAuthToken()}`,  
            },  
        });  
  
        if (!response.ok) {  
            throw new Error('Failed to delete province');  
        }  
  
        const data = await response.json();  
        return data;  
    } catch (error) {  
        console.error('Error deleting province:', error);  
        throw error;  
    }  
};  

export const uploadCertificate = async (provinceId, file) => {  
    try {  
        const formData = new FormData();  
        formData.append('certificate', file);  
  
        const response = await fetch(`/api/provinces/${provinceId}/certificate`, {  
            method: 'POST',  
            body: formData,  
            credentials: 'include',
        });  
  
        if (!response.ok) {  
            const errorData = await response.json();  
            throw new Error(`Error uploading profile photo: ${errorData.error}`);  
        }  
  
        return await response.json();  
    } catch (error) {  
        console.error('Error uploading profile photo:', error);  
        throw error;  
    }  
};  

export const getProvince = async (provinceId) => {  
    try {  
        const response = await fetch(`/api/province/${provinceId}`, {  
            method: 'GET',  
            credentials: 'include',  
            headers: {  
                'Accept': 'application/json'  
            }  
        });  
  
        if (!response.ok) {  
            const errorData = await response.json();  
            throw new Error(`Error fetching province: ${errorData.error}`);  
        }  
  
        return await response.json();  
    } catch (error) {  
        console.error('Error fetching province:', error);  
        throw error;  
    }  
};  

export const downloadCertificate = async (name, provinceId, email) => {  
    try {  
        const response = await fetchWithRetry('/api/download-certificate', {  
            method: 'POST',  
            headers: {  
                'Content-Type': 'application/json',  
            },  
            body: JSON.stringify({  
                name,  
                provinceId,  
                email,  
            }),  
        });  
  
  
        if (!response.ok) {    
            throw new Error(`Error downloading certificate: ${response.statusText}`);    
        }  
          
        return await response.json();  
  
    } catch (error) {  
        console.error('Error downloading certificate:', error);  
        throw error;  
    }  
};  

export const emailReceipt = async (name, email, receiptData) => {  
    try {  
        const response = await fetchWithRetry('/api/email-receipt', {  
            method: 'POST',  
            headers: {  
                'Content-Type': 'application/json',  
            },  
            body: JSON.stringify({  
                name,  
                email,  
                receiptData,
            }),  
        });  
  
        if (!response.ok) {  
            throw new Error(`Error sending receipt email: ${response.statusText}`);  
        }  
  
        return await response.json();  
    } catch (error) {  
        console.error('Error sending receipt email:', error);  
        throw error;  
    }  
};  

export const emailReceiptCopy = async (receipt) => {  
    try {  
        const response = await fetchWithRetry('/api/email-receipt-copy', {  
            method: 'POST',  
            headers: {  
                'Content-Type': 'application/json',  
            },  
            body: JSON.stringify({    
                receipt,
            }),  
        });  
  
        if (!response.ok) {  
            throw new Error(`Error sending receipt email: ${response.statusText}`);  
        }  
  
        return await response.json();  
    } catch (error) {  
        console.error('Error sending receipt email:', error);  
        throw error;  
    }  
};  